var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PieBase"},[_c('apexchart',{attrs:{"type":"pie","options":_vm.chartOptions,"series":_vm.chartSeries}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }